import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useDeleteTestObservationMutation} from '../hooks/useTestObservationsQuery';
import {useTestObservationsSelection} from '../hooks/useTestObservationsSelection';

// FNP-969 — single AND bulk delete. This is the capability the platform owner
// needed and did not have: clearing observations previously required a direct
// DynamoDB script.
//
// Unlike synthetic-users (which RETIRES — see that module's RetireRecordButton),
// this genuinely IS a delete: the row is discarded and does not come back. So the
// shared DeleteRecordsConfirmationButton's wording is accurate here and it is used
// as-is, rather than hand-rolling a modal.
//
// This does not make the module editable. Discarding a whole record and rewriting
// what a record says are different acts; only the first is offered.
export const DeleteRecordButton = () => {

    const deleteMutation = useDeleteTestObservationMutation();

    const {
        selection,
        handleClearSelection,
    } = useTestObservationsSelection();

    const recordIds = Object.keys(selection)
                            .filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    // Each delete is attempted independently: a rejection partway through must not
    // cancel the rest of the batch the operator confirmed, nor skip the selection
    // clear (FNP-956 precedent). The mutation's onError notifies per failure.
    const handleDelete = async () => {
        for (const id of recordIds) {
            try {
                await deleteMutation.mutateAsync(id);
            } catch {
                // notified by the mutation's onError; continue with the rest.
            }
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);
};
